import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { AppModule } from '@app/app.module';
import { environment } from '@env/environment';
import config from 'devextreme/core/config';
import { licenseKey } from './devextreme-license';
import { platformBrowser } from '@angular/platform-browser';

config({ licenseKey });

async function getTrackingId(): Promise<string | null> {
  try {
    const token = sessionStorage.getItem('jwt-token');
    if (!token) {
      return null;
    }
    const response = await fetch(environment.apiHost + '/admin_setting', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: 'Bearer ' + token
      }
    });

    const data = await response.json();
    return data.status === 'success' && data.data && data.data.wv_tracking_id ? data.data.wv_tracking_id : null;
  } catch (error) {
    console.error('Error fetching tracking ID', error);
    return null;
  }
}
(window as any).getTrackingId = getTrackingId;

if (environment.production) {
  enableProdMode();
  window.console.log = () => {
    //not to be empty
  };
  window.console.warn = () => {
    //not to be empty
  };
}

platformBrowser()
  .bootstrapModule(AppModule, { 
      applicationProviders: [
          provideZoneChangeDetection({ 
              eventCoalescing: true,
              runCoalescing: true 
          })
      ] 
  })
  .catch(err => console.error(err));
